<template>
    <!--搜索框-->
    <el-form class="search_form" :model="searchForm" ref="searchForm" size="mini" :inline="true" :rules="searchFormRules">
      <el-col :span="3">
        <el-form-item prop="operatorId">
<!--          <el-select placeholder="运营商" v-model="searchForm.operatorId" @change="operatorSelect" clearable>
            <el-option v-for="item in operatorForSelect" :key="item.id"
                       v-bind:label="item.name" v-bind:value="item.id"></el-option>
          </el-select>-->
          <el-cascader  size="mini"ref="cascader"
                        placeholder="运营商"  clearable
                        :options="operatorForSelect"
                        :props="{ checkStrictly:true,expandTrigger:'hover'}"
                        :show-all-levels="false"
                        change-on-select
                        @change='handleChangeOperator'
                        v-model="searchForm.operatorId">
          </el-cascader>
        </el-form-item>
      </el-col>
      <el-col :span="3">
        <el-form-item prop="stationId">
          <el-select placeholder="选择站" v-model="searchForm.stationId" clearable>
            <el-option v-for="item in stationsForSelect" :key="item.id"
                       v-bind:label="item.stationName" v-bind:value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-col>

      <el-col :span="3">
        <el-form-item prop="cardNo">
          <el-input placeholder="卡号" v-model="searchForm.cardNo" clearable></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="1.5">
        <el-form-item>
          <el-button size="mini" type="primary" @click="resetSearchForm">清空</el-button>
        </el-form-item>
      </el-col>
      <el-col :span="1.5">
        <el-form-item>
          <el-button type="primary"  icon="el-icon-search" @click="submitSearchForm"
                     :loading="searchLoading">查询
          </el-button>
        </el-form-item>
      </el-col>
      <el-col :span="1.5">
        <el-form-item>
          <el-button type="primary"  icon="el-icon-search" @click="exportSearchForm"
                     :loading="exportLoading">sim导出
          </el-button>
        </el-form-item>
      </el-col>
    </el-form>
</template>

<script>
  import {validateInput} from '../../../../common/validator'
  export default {
    name: "search",
    data(){
      return{
        searchFormRules: {
          cardNo: [
            {validator: function (rule, value, callback) {
                validateInput(rule, value, callback,0,20,true,true,true,true,false,false,false)
              }, trigger: 'blur'}]
        }
      }
    },
    props:{
      searchForm:{},
      operatorTypeData: '',
      searchLoading: false,
      operatorForSelect:"",
      stationsForSelect:"",
      exportLoading:false
    },
    methods:{
      resetSearchForm() {
        for(let item in this.searchForm) {
          if(this.searchForm[item]){
            this.searchForm[item] = ''
          }
        }
        this.submitSearchForm()
      },
      submitSearchForm(){
        this.$emit("submitSearchForm")
      },
      exportSearchForm(){
        this.$emit("exportSearchForm")
      },
      handleChangeOperator(value) {
        let operatorId = value &&value.length >0 ? value[value.length-1] : ''
        this.searchForm.operatorId= operatorId
        this.$refs.cascader.dropDownVisible = false
        this.$emit("operatorSelect", operatorId)
      },
      operatorSelect(val){
        this.$emit("operatorSelect", val)
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/simCardManager/search.vue